import i18next from 'i18next';
import { $rtkApi } from './rtkApi';
import { UtmTags } from 'shared/lib/utmTags';

export interface Email extends UtmTags {
    email: string;
    languageCode: string
}
export interface OTP {
    email: string;
    otp: number;
}

export interface PlatformToken {
    token: string;
    tokenLifetime: number;
    redirectUrl: string;
    setupUrl?: string;
    telegramBindUrl?: string;
}

export type RuOnboardingOtpStartResult =
    | { status: 'OTP_SENT' }
    | { status: 'ALREADY_REGISTERED' };

export type RuOnboardingOtpExchangeResult =
    | ({ status: 'AUTHENTICATED' } & PlatformToken)
    | { status: 'ALREADY_REGISTERED' };

const otpApi = $rtkApi.injectEndpoints({
    endpoints: (build) => ({
        sendOtp: build.mutation<null, Email>({
            query: (arg: Email) => {
                return {
                    url: `/api/otp`,
                    method: 'POST',
                    body: {
                        email: arg.email,
                        languageCode: i18next.language,
                        utmSource: arg.utmSource,
                        utmMedium: arg.utmMedium,
                        utmCampaign: arg.utmCampaign,
                        utmTerm: arg.utmTerm,
                        utmContent: arg.utmContent,
                    },
                };
            },
        }),
        otpExchange: build.mutation<PlatformToken, OTP>({
            query: (arg: OTP) => ({
                url: `/api/otp-exchange`,
                method: 'POST',
                body: { 
                    email: arg.email,
                    otp: arg.otp 
                },
            }),
        }),
        startRuOnboardingOtp: build.mutation<RuOnboardingOtpStartResult, Email>({
            query: (arg: Email) => ({
                url: `/api/ru-onboarding/otp`,
                method: 'POST',
                body: {
                    email: arg.email,
                    languageCode: i18next.language,
                    utmSource: arg.utmSource,
                    utmMedium: arg.utmMedium,
                    utmCampaign: arg.utmCampaign,
                    utmTerm: arg.utmTerm,
                    utmContent: arg.utmContent,
                },
            }),
        }),
        exchangeRuOnboardingOtp: build.mutation<RuOnboardingOtpExchangeResult, OTP>({
            query: (arg: OTP) => ({
                url: `/api/ru-onboarding/otp-exchange`,
                method: 'POST',
                body: {
                    email: arg.email,
                    otp: arg.otp,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export const useSendOtp = otpApi.useSendOtpMutation;
export const useOtpExchange = otpApi.useOtpExchangeMutation;
export const useStartRuOnboardingOtp = otpApi.useStartRuOnboardingOtpMutation;
export const useExchangeRuOnboardingOtp = otpApi.useExchangeRuOnboardingOtpMutation;
